import React, { useEffect, useState, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";
import "./DeviceSyncHistory.css";
import "../device-profile/DeviceProfile.css";
import MainLayout from "components/layout/main-layout/MainLayout";
import { titles } from "constants/titles";
import DeviceSyncDetailCard from "components/layout/device-sync-detail-card/DeviceSyncDetailCard";
import DeviceInfoModal from "components/layout/device-info-modal/DeviceInfoModal";
import { getDeviceSyncHistory } from "redux/Devices/actions";
import { useDispatch, useSelector } from "react-redux";
import { IconGPSDevice } from "assets/SVGs/SVGs";
import { DEVICE_SYNC_HISTORY_SUCESS } from "redux/Devices/actionTypes";
import NextPageLoaderIcon from "assets/SVGs/NextPageLoaderIcon";
import { ROUTES_CONSTANTS } from "routes/route-constants";

const DeviceSyncHistory = () => {
  const [showDeviceInfo, setShowDeviceInfo] = useState(false);
  const [fetchingMore, setFetchingMore] = useState(false);
  const loaderRef = useRef(null);
  const containerRef = useRef(null);
  const userData = useSelector((store) => store?.auth?.userData);
  const history = useHistory();

  const { deviceSyncHistory, loading, selectedDeviceDetails } = useSelector(
    (store) => store?.devices
  );
  const dispatch = useDispatch();

  useEffect(() => {
    // Reset and load first page
    getDeviceSyncHistoryList(1, false);
  }, []);

  // Hide loader once new items are appended or no more pages remain
  useEffect(() => {
    if (fetchingMore) {
      setFetchingMore(false);
    }
  }, [deviceSyncHistory?.syncHistory?.length]);

  const getDeviceSyncHistoryList = (page = 1, fetchMore = false) => {
    if (!fetchMore) {
      dispatch({
        type: DEVICE_SYNC_HISTORY_SUCESS,
        payload: [],
      });
    }
    const param = {
      dispatch,
      userType: userData?.isGuestUser ? "guestuser" : "accountowner",
      fetchMore,
      payload: {
        userDeviceId: selectedDeviceDetails?.user_device_id,
        page: page,
        limit: 10,
      },
    };
    getDeviceSyncHistory(param);
  };

  const handleScroll = useCallback(() => {
    const layoutContainer = document?.querySelector(".layout_container");
    if (layoutContainer) {
      const { scrollTop, scrollHeight, clientHeight } = layoutContainer;
      const isBottom = scrollTop + clientHeight >= scrollHeight - 20;

      if (isBottom) {
        const currentPage = deviceSyncHistory?.pagination?.currentPage || 1;
        const totalPages = deviceSyncHistory?.pagination?.totalPages || 0;
        const hasMore = currentPage < totalPages;

        if (hasMore && !loading && !fetchingMore) {
          setFetchingMore(true);
          const param = {
            dispatch,
            userType: userData?.isGuestUser ? "guestuser" : "accountowner",
            fetchMore: true,
            payload: {
              userDeviceId: selectedDeviceDetails?.user_device_id,
              page: currentPage + 1,
              limit: 10,
            },
          };
          getDeviceSyncHistory(param);
        }
      }
    }
  }, [
    deviceSyncHistory?.pagination,
    loading,
    fetchingMore,
    userData,
    selectedDeviceDetails,
    dispatch,
  ]);

  useEffect(() => {
    const layoutContainer = document.querySelector(".layout_container");
    if (layoutContainer) {
      layoutContainer.addEventListener("scroll", handleScroll);
      return () => {
        layoutContainer.removeEventListener("scroll", handleScroll);
      };
    }
  }, [handleScroll]);

  const customSchemaForUI = () => {
    return {
      deviceName: selectedDeviceDetails?.device_name,
      deviceId: selectedDeviceDetails?.provider_device_id,
    };
  };
  
  return (
    <>
      <MainLayout
        text={titles?.device_sync_history}
        isBackHide={false}
        isSemiHeader={true}
        primary={true}
        isLoading={loading && !fetchingMore}
      >
        <DeviceInfoModal
          setShow={setShowDeviceInfo}
          show={showDeviceInfo}
          selectedDeviceDetails={selectedDeviceDetails}
          deviceSchema={customSchemaForUI()}
        />
        {/* Device Profile Card */}
        <div className="dp_device_card">
          <div className="dp_device_sub_container">
            <div className="dp_device_image_container">
              {selectedDeviceDetails?.image_url ? (
                <img
                  src={selectedDeviceDetails?.image_url}
                  alt="Device"
                  className="dp_device_image"
                />
              ) : (
                <div className="dp_device_placeholder">
                  <IconGPSDevice width="32" height="32" />
                </div>
              )}
            </div>
            <div className="dp_device_description_container">
              <h2 className="dp_device_title">
                {customSchemaForUI()?.deviceName}
              </h2>
              {/* <p className="dp_device_subtitle">
                {`${selectedDeviceDetails?.firstname || ""} ${
                  selectedDeviceDetails?.lastname || ""
                }`}
              </p> */}
              <button
                className="dp_about_device_link"
                onClick={() => setShowDeviceInfo(true)}
              >
                {titles?.about_this_device}
              </button>
            </div>
          </div>
        </div>

        {/* Sync History List Container with Infinite Scroll */}
        <div ref={containerRef} className="device-sync-list-container">
          {deviceSyncHistory?.syncHistory?.length > 0 ? (
            <>
              {deviceSyncHistory?.syncHistory?.map((item, index) => (
                <DeviceSyncDetailCard
                  key={item?.syncId || item?.id || `sync-${index}`}
                  className={"mb10"}
                  syncData={item}
                  onCardClick={(data) => {
                    history.push(ROUTES_CONSTANTS.deviceSyncLogs, {
                      logs: data?.logs || [],
                      syncId: data?.syncId || null,
                    });
                  }}
                />
              ))}
              {/* Sentinel element to detect when scrolling reaches bottom */}
              <div ref={loaderRef} />
              {/* Loading indicator for infinite scroll */}
              {fetchingMore && (
                <div className="device-sync-paging-loader">
                  <NextPageLoaderIcon />
                </div>
              )}
            </>
          ) : (
            !loading && (
              <p className="display_h4 device-sync-no-data-text">
                {titles?.no_history_available}
              </p>
            )
          )}
        </div>
      </MainLayout>
    </>
  );
};

export default DeviceSyncHistory;
